import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f9975b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "third_sect" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { "data-animation": "paragraph" }, "Show Us You Love It", -1))
const _hoisted_3 = { class: "third_sect_carousel" }
const _hoisted_4 = { class: "arrows" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "24",
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.6673 2.66602L2.33398 11.9993L11.6673 21.3327M2.33398 11.9993H23.6673",
    stroke: "grey",
    "stroke-opacity": "0.31",
    "stroke-width": "3.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "24",
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.3327 2.66602L23.666 11.9993L14.3327 21.3327M23.666 11.9993H2.33268",
    stroke: "black",
    "stroke-width": "3.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "handle" }
const _hoisted_12 = { "data-animation": "paragraph" }

import croc from "@/db/croce.json";
import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'reels',
  setup(__props) {

const carousel = ref<any>(null);

const move = (a: string) => {
     if (a === "right") {
          carousel.value.scrollRight += 3000;
     }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "third_sect_carousel_wrap",
        ref_key: "carousel",
        ref: carousel
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (move('left'))),
            class: "left"
          }, _hoisted_6),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (move('right'))),
            class: "right"
          }, _hoisted_8)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(croc).tags, (tags) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "third_sect_carousel_wrap_item",
            key: tags.id
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: require(`@/assets/r${tags.id}.${tags.format}`),
                alt: ""
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(tags["@"]), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(tags.name) + " Crocs", 1)
          ]))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})